const rawSexTypes =[
    {"value":"", "label":""},
    {"value": "MALE", "label":"Male"},
    {"value": "FEMALE", "label":"Female"},
    {"value": "OTHER", "label":"Other / Prefer Not to Answer"}
  ];

export default rawSexTypes;